export interface ShareModalSummaryInput {
  reference?: string | null;
  description?: string | null;
  location?: string | null;
  url?: string | null;
}

function cleanText(value?: string | null): string {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function buildShareModalSummaryText(input: ShareModalSummaryInput): string {
  const reference = cleanText(input.reference);
  const description = cleanText(input.description);
  const location = cleanText(input.location);
  const url = cleanText(input.url);

  return [
    reference,
    description,
    location ? `Location: ${location}` : null,
    url,
  ]
    .filter(Boolean)
    .join('\n\n');
}
